import type { DropTargetOptions } from '@affine/component';
import { isFavoriteSupportType } from '@affine/core/modules/favorite';
import type { AffineDNDData } from '@affine/core/types/dnd';

import type { NavigationPanelTreeNodeDropEffect } from '../../tree';

function isFavoriteListSource(data: {
  source: { data: AffineDNDData['draggable'] };
}) {
  const entityType = data.source.data.entity?.type;
  return (
    data.source.data.from?.at === 'navigation-panel:favorite:list' &&
    !!entityType &&
    isFavoriteSupportType(entityType)
  );
}

export const favoriteChildrenDropEffect: NavigationPanelTreeNodeDropEffect =
  data => {
    if (
      (data.treeInstruction?.type === 'reorder-above' ||
        data.treeInstruction?.type === 'reorder-below') &&
      isFavoriteListSource(data)
    ) {
      return 'move';
    }
    return; // not supported
  };

export const favoriteRootDropEffect: NavigationPanelTreeNodeDropEffect =
  _data => {
    return undefined;
  };

export const favoriteRootCanDrop: DropTargetOptions<AffineDNDData>['canDrop'] =
  _data => {
    return false;
  };

export const favoriteChildrenCanDrop: DropTargetOptions<AffineDNDData>['canDrop'] =
  data => isFavoriteListSource(data);
